<span *ngIf="Count > 0">{{Count}}</span>